export function isAssets( url: string ): boolean {
   const substr = url.substring( 0, url.indexOf( '/' ));

   return substr === 'assets';
}
